import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from "@mui/material";
import { useTranslation } from 'react-i18next';


const ScreenRouteVehicleStatusTable = ({ loading, error, vehicleData, formatDistance, formatTime }) => {
    const { t } = useTranslation()
    const sortedVehicles = Object.values(vehicleData || {})
        .sort((a, b) => {
            const distA = parseFloat(a.distance);
            const distB = parseFloat(b.distance);
            if (isNaN(distA) && isNaN(distB)) return 0;
            if (isNaN(distA)) return 1;
            if (isNaN(distB)) return -1;
            return distA - distB;
        });

    return (
        <TableContainer component={Paper} elevation={3}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell
                            sx={{
                                fontWeight: 'bold',
                                backgroundColor: 'rgba(32, 168, 224, 1)',
                                color: 'white',
                                fontSize: '0.8rem'
                            }}
                        >
                            {t("Vehicle ID")}
                        </TableCell>
                        <TableCell
                            sx={{
                                fontWeight: 'bold',
                                backgroundColor: 'rgba(32, 168, 224, 1)',
                                color: 'white',
                                fontSize: '0.8rem'
                            }}
                        >
                            {t("Distance")}
                        </TableCell>
                        <TableCell
                            sx={{
                                fontWeight: 'bold',
                                backgroundColor: 'rgba(32, 168, 224, 1)',
                                color: 'white',
                                fontSize: '0.8rem'
                            }}
                        >
                            {t("ETA")}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {error ? (
                        <TableRow>
                            <TableCell
                                colSpan={3}
                                sx={{
                                    textAlign: 'center',
                                    color: 'error.main',
                                    py: 2
                                }}
                            >
                                {error}
                            </TableCell>
                        </TableRow>
                    ) : sortedVehicles.length === 0 ? (
                        <TableRow>
                            <TableCell
                                colSpan={3}
                                sx={{
                                    textAlign: 'center',
                                    py: 2
                                }}
                            >
                                {t("No vehicle data available")}
                            </TableCell>
                        </TableRow>
                    ) : (
                        sortedVehicles.map((data) => (
                            <TableRow
                                key={data.device_id}
                                sx={{
                                    '&:nth-of-type(odd)': {
                                        backgroundColor: '#fafafa',
                                    },
                                    '&:hover': {
                                        backgroundColor: '#f0f0f0',
                                    },
                                }}
                            >
                                <TableCell sx={{ fontWeight: '500', fontSize: "0.8rem" }}>
                                    {data?.device_id}
                                </TableCell>
                                <TableCell sx={{ fontWeight: '500', fontSize: "0.8rem" }}>
                                    {isNaN(data.distance) ? 0 : formatDistance(data.distance)}
                                </TableCell>
                                <TableCell sx={{ fontWeight: '500', fontSize: "0.8rem" }}>
                                    {isNaN(data.eta) ? 0 : formatTime(data.eta)}
                                </TableCell>
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ScreenRouteVehicleStatusTable;